<template>
  <div class="CollectAcritle">
    <p class="acritleNumber">{{$t('collect.共')}}{{ index }}{{$t('collect.个活动')}}</p>
    <ul class="activityUl clearfix">
      <li
        class="activityLi"
        v-for="(item, i) in list"
        :key="i"
        @click.stop.prevent="goto(item.id)"
      >
        <div class="activityImg">
          <img :src="item.thumb | imageUrl('', 510, 678)" alt />
          <!-- <p class="title1" v-if="item.type == 1">直播</p>
          <p class="title2 liveing" v-if="item.type == 1 && item.status == 5">
            直播中
          </p> -->
          <p class="title2 begining" v-if="item.status == 2">{{$t('live.即将开始')}}</p>
          <p class="title2 Finished" v-if="item.status == 4">{{$t('global.已结束')}}</p>
          <p class="title2 liveing" v-if="item.status == 5">{{$t('global.进行中')}}</p>
        </div>
        <p class="title3">{{ item.title }}</p>
        <p class="title4">
          {{ item.holdStartTime | formatDate("YYYY.MM.DD") }} -
          {{ item.holdEndTime | formatDate("YYYY.MM.DD") }}
        </p>
        <div>
          <el-popover placement="bottom" trigger="hover">
            <div class="operationTitle">
              <p class="title1" @click="closeVideo(item.id)">{{$t('collect.取消收藏')}}</p>
            </div>
            <span class="operation" slot="reference"
              ><img
                src="/static/collect/icon_playlist_video_dots@2x.png"
                alt=""
            /></span>
          </el-popover>
        </div>
      </li>
    </ul>
    <div class="createPop" v-if="cleateLookPop">
      <div class="popBox popBox1">
        <p class="popTitle">
          <span class="title1">{{$t('collect.取消收藏')}}</span>
        </p>
        <p class="textTitle">{{$t('collect.是否取消收藏该视频？')}}</p>
        <div class="buttom1 buttom2">
          <div class="butBox">
            <span class="cel" @click="closeLook">{{$t('collect.是')}}</span
            ><span class="cir" @click="cleateLookPop = false">{{$t('collect.否')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollectAcritle",
  props: ["list", "index"],
  data() {
    return {
      cleateLookPop: false,
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  methods: {
    closeLook(id) {
      let params = {
        domainType: 3,
        type: 2,
      };
      this.$http.post("/api/u/relation/comment/" + id, params).then((res) => {
        this.$message.success(res.message);
        this.$emit("getList");
        this.cleateLookPop = false;
      });
    },
    closeVideo(id) {
      // this.cleateLookPop = true;
      // this.videoId = id;
      this.closeLook(id)
    },
    goto(id) {
      this.$router.push("/activityDetail/"+ id)
    }
  },
};
</script>
<style>
/* .el-popover {
  min-width: auto;
  padding: 10px 0;
} */
.operationTitle .title1 {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  text-align: center;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  cursor: pointer;
}
.operationTitle .title1:hover {
  background: #f5f5f5;
}
</style>
<style lang="stylus" scoped>
.CollectAcritle {
  padding: 0 35px 50px;

  .acritleNumber {
    height: 23px;
    font-size: 15px;
    font-weight: 400;
    color: #999999;
    line-height: 23px;
    margin-bottom: 30px;
  }

  .activityUl {
    .activityLi {
      float: left;
      margin-right: 24px;
      margin-bottom: 30px;
      width: 235px;
      height: 417px;
      cursor: pointer;
      position: relative;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .activityImg {
        width: 235px;
        height: 313px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .title1 {
          position: absolute;
          width: 48px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 2px;
          right: 10px;
          bottom: 10px;
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
        }

        .title2 {
          position: absolute;
          width: 88px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: rgba(255, 255, 255, 1);
          left: 0;
          bottom: -15px;
          font-size: 14px;
          font-weight: 500;
        }

        .liveing {
          border: 1px solid rgba(254, 86, 48, 1);
          color: #FE5630;
        }

        .begining {
          border: 1px solid rgba(32, 38, 204, 1);
          color: #2026CC;
        }

        .Finished {
          border: 1px solid rgba(102, 102, 102, 1);
          color: #666666;
        }

        .haveing {
          border: 1px solid rgba(32, 38, 204, 1);
          color: #2026CC;
        }

        &:hover .liveing {
          background: #FE5630;
          color: #fff;
        }

        &:hover .begining {
          background: #2026CC;
          color: #fff;
        }

        &:hover .Finished {
          background: #666666;
          color: #fff;
        }

        &:hover .haveing {
          background: #FE5630;
          color: #fff;
        }
      }

      .title3 {
        width: 100%;
        margin: 30px 0 9px 0;
        font-size: 16px;
        height: 44px;
        line-height: 22px;
        font-weight: 600;
        color: #0A0A0A;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-clamp: 2;
      }

      .title4 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }

      .operation {
        position: absolute;
        right: 0;
        bottom: 0;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}

.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popBox {
    width: 445px;
    height: 362px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      box-sizing: border-box;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .title1 {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-right: 16px;
      }

      .title2 {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }

      .close {
        position: absolute;
        right: 24px;
      }
    }

    .from1 {
      padding: 20px 24px 0;
      height: 230px;
      box-sizing: border-box;
      overflow-y: scroll;

      .nameBox {
        margin-bottom: 16px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
      }
    }

    .buttom1 {
      border-top: 1px solid #E0E0E0;
      height: 70px;
      padding: 20px 24px;
      box-sizing: border-box;
      text-align: center;

      .create {
        float: left;
        font-size: 15px;
        font-weight: 400;
        color: #3664ED;
        cursor: pointer;
      }

      .butBox {
        .cel {
          width: 90px;
          height: 30px;
          border: 1px solid #999999;
          box-sizing: border-box;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          margin-right: 20px;
          cursor: pointer;
        }

        .cir {
          width: 90px;
          height: 30px;
          background: #2026CC;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }

  .popBox1 {
    height: 220px;
    width: 380px;

    .textTitle {
      height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      text-align: center;
      margin: 27px 0 32px 0;
    }

    .buttom2 {
      border-top: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/CollectActivity.vue